import { Component, OnInit } from '@angular/core';
import { TranslateHelper } from '@app/_helpers';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-vendor-form-success',
    templateUrl: './vendor-form-success.component.html',
    styleUrls: ['./vendor-form-success.component.scss'],
    standalone: true,
    imports: [TranslateModule]
})
export class VendorFormSuccessComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
